import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import Amplitude from "@Shared/utils/amplitude";
import Err from "../../../../../../routes/error";
import { ADD_FOLLOW_UP } from "@Broker/@Modules/clients/board/store/board-actions";
import { UPDATE_ACCOUNT_PREFERENCES } from "@Broker/@Modules/main/store/account/account-actions";
import { mapActions, mapGetters } from "vuex";
import CheckboxSection from "@Shared/components/sections/checkbox-section";
import AssigneeSelect from "../shared/assignee-select";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { futureDate, requiredHTML } from "@Shared/@Utils/validation-rules";
import RichTextEditor from "@Shared/utils/rich-text-editor";
import { showToast } from "@Shared/utils/constants";
import TimeInput from "../../../../../../modules/automation/automation/components/argument-types/time";
import DateSection from "@Shared/components/sections/date-section.vue";
import Field from "@Shared/components/sections/field.vue";
import { CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS, CLIENT_PROFILE_CUSTOM_FIELDS_TAGS } from "../../../store/board-getters";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FollowUpTab",
  components: {
    AssigneeSelect,
    CheckboxSection,
    TimeInput,
    DateSection,
    Field
  },
  mixins: [validationMixin],
  props: {
    tabData: {
      type: Object,
      default: () => ({})
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    currentTab: {
      type: String,
      required: true
    },
    formId: {
      type: String,
      default: "follow-up"
    }
  },
  data() {
    return _objectSpread(_objectSpread({
      description: "",
      scheduledDate: "",
      scheduledTime: this.followUpNotificationTime,
      assignees: []
    }, this.tabData), {}, {
      currentDate: moment().startOf("day"),
      maxCharacterCount: 4000
    });
  },
  validations: {
    description: {
      required: requiredHTML
    },
    scheduledDate: {
      required,
      futureDate
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", ["getProfileOwner", "getDefaultAssignees", CLIENT_PROFILE_CUSTOM_FIELDS_TAGS, CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS])), mapFields("AccountStore", ["accountPreferences.followUpNotificationTime"])), {}, {
    owner() {
      return this.getProfileOwner(this.clientProfileId);
    },
    followUpId() {
      return this.tabData.id;
    },
    isDefaultTime() {
      return this.scheduledTime === this.followUpNotificationTime;
    },
    defaultAssigneesUsernames() {
      var _context;
      return _mapInstanceProperty(_context = this.getDefaultAssignees(this.clientProfileId)).call(_context, ({
        username
      }) => username);
    },
    canSave() {
      return !this.$v.$invalid && !this.isMaxLengthReached;
    },
    customFieldsTags() {
      return this.CLIENT_PROFILE_CUSTOM_FIELDS_TAGS(this.clientProfileId);
    },
    customFieldsHintsTags() {
      return this.CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS(this.clientProfileId);
    },
    characterCount() {
      const textOnly = this.description.replace(/<[^>]*>/g, "");
      return textOnly.length;
    },
    isMaxLengthReached() {
      return this.characterCount >= this.maxCharacterCount;
    }
  }),
  watch: {
    customFieldsTags: {
      deep: true,
      handler(value) {
        this.editor.updateOptions({
          mergeTags: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    },
    customFieldsHintsTags: {
      deep: true,
      handler(value) {
        this.editor.updateOptions({
          hints: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    },
    owner(newOwner, oldOwner) {
      if (isEmpty(oldOwner) || !(oldOwner != null && oldOwner.username)) return;
      if (newOwner.username !== oldOwner.username) {
        this.resetAssignees();
      }
    },
    followUpNotificationTime(val) {
      this.scheduledTime = val;
    }
  },
  mounted() {
    this.scheduledTime = this.followUpNotificationTime;
    this.initTab();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("BoardStore", [ADD_FOLLOW_UP])), mapActions("AccountStore", [UPDATE_ACCOUNT_PREFERENCES])), {}, {
    initEditor() {
      const target = $(this.$refs.descriptionField);
      this.editor = new RichTextEditor(target, {
        placeholder: this.$t("global.actions.enterDescription"),
        airMode: true,
        height: "6vw",
        substitutionHints: true,
        showMergeTags: true,
        loadPreferences: false,
        visible: true,
        blockPastedImages: false,
        sanitizeContent: RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia,
        mergeTags: defaults => {
          return [...defaults, ...this.customFieldsTags];
        },
        hints: defaults => {
          return [...defaults, ...this.customFieldsHintsTags];
        },
        callbacks: {
          onChange: this.handleEditorChange
        }
      });
      $(".note-codable").attr("id", "enter-description-id");
    },
    handleEditorChange(_, content) {
      this.description = content;
    },
    async handleSubmit() {
      const submitButton = $(this.$refs.submitFollowUp);
      try {
        submitButton.animateButton().animate("start");
        await this.ADD_FOLLOW_UP({
          id: this.clientProfileId,
          followUp: {
            description: this.editor.getHTML(),
            scheduledDate: this.scheduledDate,
            scheduledTime: this.scheduledTime,
            assignees: this.assignees
          }
        });
        this.$emit("submit");
        this.resetFields();
        showToast("success", "activityAdded");
        Amplitude.updateCount("CLIENT_PROFILE_FOLLOWUPS_CREATED");
        await submitButton.animateButton().animate("finish");
        submitButton.removeClass("form-finish");
        this.$emit("add");
      } catch (e) {
        Err.handle(e);
        await submitButton.animateButton().animate("finish", "failed");
      }
    },
    handleScheduledDateChange(value) {
      this.scheduledDate = value;
    },
    handleNotifyChange(data, type) {
      if (type === "select") {
        data.forEach(assignee => {
          var _context2;
          if (!_includesInstanceProperty(_context2 = this.assignees).call(_context2, assignee.username)) {
            this.assignees.push(assignee.username);
          }
        });
      } else if (type === "unselect") {
        var _context3;
        this.assignees = _filterInstanceProperty(_context3 = this.assignees).call(_context3, username => username !== data.username);
      }
    },
    resetAssignees() {
      this.assignees = this.defaultAssigneesUsernames;
    },
    initTab() {
      this.resetAssignees();
      this.initEditor();
    },
    async handleDefaultTime(checked) {
      if (checked) {
        this.followUpNotificationTime = this.scheduledTime;
        this.UPDATE_ACCOUNT_PREFERENCES();
      }
    },
    async resetFields() {
      this.editor.setHTML("");
      this.description = "";
      this.scheduledDate = "";
      this.scheduledTime = this.followUpNotificationTime;
      this.resetAssignees();
      await this.$nextTick();
      this.$v.$reset();
    }
  })
});